import type { Channel } from 'stream-chat';

const getOtherParticipantsFirstNames = (
  channelMembers: Channel['state']['members'],
  currentUserId: string,
  includeFirstLetterFromLastName = false,
  excludeAnd = false,
) => {
  if (!channelMembers) return '';

  const filteredMembers = Object.values(channelMembers).filter(
    member => member.user.id !== currentUserId,
  );

  const names = includeFirstLetterFromLastName
    ? filteredMembers.map(member => {
        const [firstName, lastName] = member.user.name.split(' ');
        return `${firstName} ${lastName.charAt(0)}`;
      })
    : filteredMembers.map(member => member.user.name.split(' ').at(0));
  if (excludeAnd || names.length === 1) return names.join(', ');
  const firsts = names.slice(0, names.length - 1);
  const last = names[names.length - 1];
  return `${firsts.join(', ')}  and ${last}`;
};

export default getOtherParticipantsFirstNames;
